import { useCallback, FC, MouseEventHandler } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import styled from 'styled-components';
import { DisabledProps, linkMixin } from 'ui/Styled/Styled';
import { TextS } from 'ui/Styled/Styled';

type LinkProps = Omit<React.ComponentProps<typeof RouterLink>, 'ref'>;

export const Link: FC<LinkProps> = ({ onClick, ...props }) => {
    const handleClick = useCallback<MouseEventHandler<HTMLAnchorElement>>(
        (e) => {
            onClick?.(e);
        },
        [onClick]
    );

    return (
        <RouterLink onClick={handleClick} unstable_viewTransition {...props} />
    );
};

const StyledLink = styled(Link)`
    ${linkMixin}
`;

const StyledRawLink = styled.a<DisabledProps>`
    ${linkMixin}
`;

export const StyledTextLink = styled.div<DisabledProps>`
    ${linkMixin}
`;

export const BlueLink = styled(Link)`
    color: rgb(
        113,
        142,
        191
    ); // можно использовать другой голубой, если есть в теме
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
`;

export const StandartLink = ({ children, ...props }: LinkProps) => {
    return (
        <StyledLink {...props}>
            <TextS>{children}</TextS>
        </StyledLink>
    );
};

type RawLinkProps = {
    disabled?: boolean;
    onClick?: () => void;
    href?: string;
    children: React.ReactNode;
};

export const RawLink = ({ children, disabled, ...props }: RawLinkProps) => {
    const content = <TextS>{children}</TextS>;

    return props.href ? (
        <StyledRawLink $disabled={disabled} {...props}>
            {content}
        </StyledRawLink>
    ) : (
        <StyledTextLink $disabled={disabled} {...props}>
            {content}
        </StyledTextLink>
    );
};
